import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import { toastr } from "react-redux-toastr";

import { Modal } from "components";
import { client_v2 } from "utils/api";

/** redux-form przekazuje `step`/`min` jako osobne propsy — Input rozszerza `input`. */
const InputField = ({ input, meta, step, min, max, ...rest }) => (
  <Input
    input={{
      ...input,
      ...(step !== undefined ? { step } : {}),
      ...(min !== undefined ? { min } : {}),
      ...(max !== undefined ? { max } : {}),
    }}
    meta={meta}
    {...rest}
  />
);

const FORM_NAME = "pieceworker-rate-schedule";

const validate = (values) => {
  const errors = {};
  if (!values.effective_from) {
    errors.effective_from = "Wymagane";
  }
  const w = Number(values.weekday_rate);
  const we = Number(values.weekend_rate);
  if (Number.isNaN(w) || w <= 0) {
    errors.weekday_rate = "Podaj dodatnią liczbę";
  }
  if (Number.isNaN(we) || we <= 0) {
    errors.weekend_rate = "Podaj dodatnią liczbę";
  }
  return errors;
};

const PieceworkerRateScheduleModal = ({
  handleSubmit,
  onClose,
  userId,
  onSaved,
}) => {
  const submit = async (values) => {
    try {
      await client_v2.post(`/users/${userId}/pieceworker_rate_schedules`, {
        effective_from: values.effective_from,
        weekday_rate: Number(values.weekday_rate),
        weekend_rate: Number(values.weekend_rate),
      });
      toastr.success("Sukces", "Dodano wpis stawek");
      onSaved?.();
      onClose();
    } catch (err) {
      toastr.error("Błąd", "Nie udało się zapisać stawek");
    }
  };

  return (
    <Modal
      header={{
        title: "Nowy wpis (kolejna zmiana stawek)",
      }}
      handleClose={onClose}
      footer={
        <>
          <Button type="cancel" onClick={onClose} />
          <Button type="save" text="Zapisz" onClick={handleSubmit(submit)} />
        </>
      }
    >
      <form noValidate onSubmit={handleSubmit(submit)}>
        <div className="dashboard-wrapper-flex m-b-20">
          <div className="column-half">
            <Field
              name="effective_from"
              label="Obowiązuje od (data)"
              type="date"
              component={InputField}
            />
          </div>
        </div>
        <div className="dashboard-wrapper-flex">
          <div className="column-half">
            <Field
              name="weekday_rate"
              label="Mnożnik — dni powszednie"
              type="number"
              component={InputField}
              step="0.0001"
              min="0"
            />
          </div>
          <div className="column-half">
            <Field
              name="weekend_rate"
              label="Mnożnik — weekend"
              type="number"
              component={InputField}
              step="0.0001"
              min="0"
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: true,
})(PieceworkerRateScheduleModal);
